import { createFileRoute } from '@tanstack/react-router'
import { DropsPage } from '~/features/admin/drops-page'

export const Route = createFileRoute('/admin/drops')({
  component: DropsPage,
})
